import { createSelector, current } from '@reduxjs/toolkit';
import { isCoverDeclined } from '../utilities/application/enquiryHelper';

const getQuoteLoading = (state) => state.quote.loading;
const getQuote = (state) => state.quote.data;
export const getQuoteApplicants = (state) => state.quote.data.quoteApplicants;
export const getQuotePremium = (state) => state.quote.data.premium;
export const getQuoteError = (state) => state.quote.error;
export const getQuoteCreatedDate = (state) => state.quote.data.quoteCreatedDate;

const getQuoteLoadingSelector = createSelector(
  [getQuoteLoading],
  (getQuoteLoading) => {
    return getQuoteLoading;
  }
);

export const getIsValidQuote = createSelector(getQuote, (quote) => {
  if (Number(quote.premium) && quote.premium > 0) {
    return true;
  }
  return false;
});

export const getQuoteCoversByApplicantId = createSelector(
  [getQuoteApplicants, (state, applicantId) => applicantId],
  (quoteApplicants, applicantId) => {
    const quoteApplicant = quoteApplicants.find(
      (applicant) => applicant.id === applicantId
    );
    return quoteApplicant ? quoteApplicant.quoteCovers : [];
  }
);

export const getQuoteDecisionsApplicantId = createSelector(
  [getQuoteApplicants, (state, applicantId) => applicantId],
  (quoteApplicants, applicantId) => {
    const quoteApplicant = quoteApplicants.find(
      (applicant) => applicant.id === applicantId
    );
    try {
      const quoteDecisions = quoteApplicant.quoteDecisionModel.quoteDecisions;
      return quoteDecisions;
    } catch {
      return [];
    }
  }
);

export const hasQuoteDeclined = createSelector(
  getQuoteApplicants,
  (quoteApplicants) => {
    return (
      quoteApplicants.filter(
        (quoteApplicant) =>
          quoteApplicant.quoteCovers.findIndex((quoteCover) =>
            isCoverDeclined(quoteCover.decision)
          ) !== -1
      ).length > 0
    );
  }
);

export const getQuoteApplicantsPremiums = createSelector(
  getQuoteApplicants,
  (quoteApplicants) => {
    return quoteApplicants.map((quoteApplicant) => ({
      applicantId: quoteApplicant.id,
      premium: quoteApplicant.premium,
    }));
  }
);

/**
 * Get the applicant index from the quote applicants array
 */
export const getQuoteApplicantIndex = createSelector(
  [getQuoteApplicants, (state, applicantId) => applicantId],
  (applicants, applicantId) =>
    applicants.findIndex((applicant) => applicant.id === applicantId)
);

export const getQuoteApplicantIndexFromMeta = (state, action) => {
  let applicantId = action.meta.arg.applicantId
    ? action.meta.arg.applicantId
    : action.meta.arg;

  let index = getQuoteApplicantIndex({ quote: current(state) }, applicantId);
  return index;
};

export default {
  getQuoteLoadingSelector,
};
